module.exports = __webpack_public_path__ + "static/media/menu_createRole_default.c02d0ecb.svg";